<template>
	<div class="modal" :class="{'is-active': display}" v-cloak>
		<div class="modal-background" @click="$emit('close')"></div>
		<div class="modal-card welcome-modal">
			<header class="welcome-header">
				<h5 class="modal-card-title welcome-title title is-5 is-fullwidth-mobile">
					<slot name="title">
						{{ title }}
					</slot>
				</h5>
				<i class="fa fa-close is-clickable" aria-label="close" @click="$emit('close')"></i>
			</header>
			<form @submit.prevent="$emit('submit')">
				<slot name="header"></slot>
				<section class="welcome-body">
					<flashes :alerts="alerts.data" v-if="alerts && alerts.action === 'modal'"></flashes>
					<slot></slot>
				</section>
				<footer class="welcome-footer">
					<slot name="footer"></slot>
				</footer>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'title',
		'alerts',
		'display',
	],
}
</script>

